import { lazy, Suspense } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import SEOJsonLd from '../../components/feature/SEOJsonLd';

const HowItWorks   = lazy(() => import('./components/HowItWorks'));
const RevenueModel = lazy(() => import('./components/RevenueModel'));
const Benefits     = lazy(() => import('./components/Benefits'));
const Positioning  = lazy(() => import('./components/Positioning'));
const SocialProof  = lazy(() => import('./components/SocialProof'));
const FAQ          = lazy(() => import('./components/FAQ'));
const FinalCTA     = lazy(() => import('./components/FinalCTA'));
const Footer       = lazy(() => import('./components/Footer'));

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://vetuvia.com';

function SectionFallback() {
  return <div className="w-full py-20 bg-white" aria-hidden="true" />;
}

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <SEOJsonLd
        title="Veterinary Telehealth & Commerce Platform | Vetuvia"
        description="Vetuvia helps veterinarians create recurring income through telehealth, memberships, curated product sales, and subscription care—all from one platform."
        keywords="Telehealth, dog, cat, dogs, cats, vets, veterinarian income, veterinary teleconsults, vet memberships, subscription care plans, veterinary digital services, Meng Hsuan Chuang"
        canonical={`${siteUrl}/`}
        ogImage="https://static.readdy.ai/image/f30444846e2254d95b405efc135ce378/b4d09c4f03ec4a157d9695deb6f4dc19.png"
      />
      <Navbar />
      <Hero />
      <Suspense fallback={<SectionFallback />}>
        <HowItWorks />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <RevenueModel />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <Benefits />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <Positioning />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <SocialProof />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <FAQ />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <FinalCTA />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <Footer />
      </Suspense>
    </div>
  );
}
